
export default {
  name: 'CardAction',
  props: {
    cardAction: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    // The SEO contract specifies a `uyumlu_urunler_ve_dikey_cozumler` button_location
    // for action cards on the pricing page. Other CardAction usages emit a generic
    // button_click with a slug-derived location so they're still trackable.
    trackClick() {
      if (!this.$gtm || !this.$gtm.pushButtonClickEvent) return
      const label = (this.cardAction && this.cardAction.title) || ''
      if (!label) return
      const path = (typeof window !== 'undefined' && window.location.pathname) || ''
      const onPricingPage = /\/fiyat[-_]?listesi|\/fiyatlar?-/.test(path)
      const location = onPricingPage
        ? 'uyumlu_urunler_ve_dikey_cozumler'
        : 'card_action'
      this.$gtm.pushButtonClickEvent(label, location)
    },
  },
}
